export default __webpack_public_path__ + "static/media/Man.dccfb1e0.png";